import type {
    AddressType,
    CartType,
    FavoriteType,
    PointUserType,
} from "@/types/user-type";
import { createContext, type Dispatch, type SetStateAction } from "react";

export const UserContext = createContext<{
    point: PointUserType | null;
    setPoint: Dispatch<SetStateAction<PointUserType | null>>;
    vUsage: number[] | null;
    setVUsage: Dispatch<SetStateAction<number[] | null>>;
    address: AddressType[] | null;
    setAddress: Dispatch<SetStateAction<AddressType[] | null>>;
    cart: CartType[] | null;
    setCart: Dispatch<SetStateAction<CartType[] | null>>;
    favorite: FavoriteType[] | null;
    setFavorite: Dispatch<SetStateAction<FavoriteType[] | null>>;
}>({
    point: null,
    setPoint: () => null,
    vUsage: null,
    setVUsage: () => null,
    address: null,
    setAddress: () => null,
    cart: null,
    setCart: () => null,
    favorite: null,
    setFavorite: () => null,
});
